<template>
<div v-loading.fullscreen.lock="loader">
  <div align="right">
    <el-input v-model="searchText" style="width: 10rem; outline: none;" prefix-icon="el-icon-search" placeholder="search">
    </el-input>
  </div>
  <br>
  <el-table
  :data="filteredData"
  stripe
  max-height="400"
  style="width: 100%;"
  @selection-change="handleSelectionChange">
  <el-table-column
    type="selection"
    min-width="60">
  </el-table-column>
  <el-table-column
    type="index"
    label="Sr. No."
    min-width="100"
  >
  </el-table-column>
  <el-table-column
    prop="first_name"
    align="center"
    label="First Name"
    min-width="150">
  </el-table-column>
  <el-table-column
    prop="last_name"
    align="center"
    label="Last Name"
    min-width="150">
  </el-table-column>
  <el-table-column
    prop="email"
    align="center"
    label="Email Id"
    min-width="220">
  </el-table-column>
  <el-table-column
    prop="status"
    align="center"
    label="Status"
    min-width="220">
  </el-table-column>
  </el-table>
  <br>
  <div align="right">
    <el-button class="btn-theme" @click="SendMail()">Send Welcome Mail</el-button>
  </div>
</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: ['tableData1'],
  data () {
    return {
      searchText: '',
      SelectAllCB: false,
      loader: false,
      checkedStatus: [],
      SelectedUserList: [],
      multipleSelection: []
    }
  },
  computed: {
    ...mapGetters({
      getWelcomeMail: 'Survey/getWelcomeMail'
    }),
    filteredData () {
      return this.tableData1.filter((ele) => {
        return ele.first_name.toLowerCase().match(this.searchText.toLowerCase())
      })
    }
  },
  methods: {
    ...mapActions({
      sendWelcomeMail: 'Survey/sendWelcomeMail'
    }),
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log('THIS MUKTIPLE SELECTION', this.multipleSelection)
    },
    SendMail () {
      var arr = []
      if (this.multipleSelection.length !== 0) {
        this.multipleSelection.forEach(ele => {
          arr.push(ele.id)
        })
        console.log('ARR', arr)
        this.loader = true
        this.sendWelcomeMail({
          users: arr
        })
      } else {
        this.$message.error('Select users to send mail')
      }
    }
  },
  watch: {
    SelectAllCB (value) {
      console.log('Value', value)
    },
    SelectedUserList (value) {
      console.log('Selected user list', value)
    },
    getWelcomeMail (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success === true) {
        this.$message.success(value.message)
      } else {
        this.$message.error(value.message)
      }
      this.loader = false
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/WelcomeMail/welcomeMailUsersTable.vue